import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TenantRoomEventType, TenantRoomMessage, UserType } from '@jms/model';
import { ApplicationActions } from '@jms/tenant/module.jms.state';
import { AuthTokenService } from '@jms/utils/util.authentication';
import { CurrentUserService } from '@jms/ui/ui.standalone.services/current.user.service';
import { TenantRoomSocketService } from '@workbuddy/services/socket/tenant.room.socket.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceSocketService {

  private readonly actions = inject(ApplicationActions);
  private readonly authTokenService = inject(AuthTokenService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly tenantRoom = inject(TenantRoomSocketService);

  constructor() {

    this.tenantRoom.events$
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(event => this.handleTenantRoomEvent(event));
  }

  private handleTenantRoomEvent(event: TenantRoomMessage): void {

    if (event.type !== TenantRoomEventType.MaintenanceMode) {
      return;
    }

    // System Administrators keep access so they can disable maintenance mode.
    if (this.currentUserService.$role()?.type === UserType.SystemAdministrator) {
      return;
    }

    // Ignore the echo of our own logout — otherwise the second dispatch navigates the
    // page and cancels the in-flight logout request before its response is read.
    if (this.authTokenService.isLoggingOut()) {
      return;
    }

    this.actions.logout(true);
  }
}
